import React, { useEffect, useState } from "react";
import { ThemeProvider } from "@material-ui/styles";
import { createTheme } from "@material-ui/core/styles";
import Session from "react-session-api";
import LoginGlass from "./components/LoginGlass";
import NavBar from "./components/biztran_controls/NavBar";
import { Route, Router } from "react-router-dom";
import CustomerPage from "./components/SerialNumber/CustomerPage";

// const theme = createTheme({
//   palette: {
//     primary: {
//       main: "#857676",
//       dark: "#202d73",
//       text: "#ffffff",
//       icons: "#857676",
//       gradient: "linear-gradient(90deg,  #E51C24,#E51C24)",
//       IwColor:"#1E90FF",
//       ImColor:"#FF6347",
//       PSTColor:"#4682B4",
//     },
//     secondary: {
//       main: "#88E51C",
//       //main: "#00239CFF",
//       dark: "#b51009",
//       text: "#000000",
//       icons: "#E51C24",
//       gradient: "linear-gradient(90deg, #E51C24, #E51C24)",
//     },
//     tertiary: {
//       main: "#909090",
//       gradient: "linear-gradient(90deg, #909090, #909090)",
//     },
//   },
// });

const theme = createTheme({
  palette: {
    primary: {
      main: "#980a0a",
      dark: "#202d73",
      text: "white",
      //text: "black",
      red: "#E0210E",
      icons: "black",
      //button: "#808080",
      button: "#7f2153",
      gradient: "linear-gradient(90deg,  #E51C24,#E51C24)",
      IwColor: "#fafafa",
      ImColor: "#fafafa",
      PSTColor: "#fafafa",
    },
    secondary: {
      //main: "#980a0a",
      main: "#CECECE",
      //grid: "#CECECE",
      grid: "#808080",
      //button: "#808080",
      button: "#7f2153",
      red: "#E0210E",
      // hover: '#4bc0fa',
      hover: '#CECECE',
      dark: "#b51009",
      text: "#000000",
      icons: "black",//"#E51C24",
      gradient: "linear-gradient(90deg, #E51C24, #E51C24)",
    },
    tertiary: {
      main: "#909090",
      background: "black",
      gradient: "linear-gradient(90deg, #909090, #909090)",
    },
  },
});

const App = () => {
  const [IsLoggedIn, setIsLoggedIn] = useState(false);
  const [IsCustomer, setIsCustomer] = useState(false);
  useEffect(() => {
    Session.onSet(setLoginStatus);
    Session.config(true, 30);
    if (
      Session.get("UID") !== undefined &&
      Session.get("UID") !== "" &&
      Session.get("UID") !== null
    ) {
      //console.log(Session.get("UID"));
      setIsLoggedIn(true);
    }
    //console.log(Session.get("UID"));
  }, []);

  const setLoginStatus = (data) => {
    if (
      data["UID"] === undefined ||
      data["UID"] === "" ||
      data["UID"] === null
    ) {
      setIsLoggedIn(false);
    } else {
      setIsLoggedIn(true);
    }
  };
  // if (IsCustomer === false) {
  //   return (
  //     <ThemeProvider theme={theme}>
  //       <CustomerPage />
  //     </ThemeProvider>
  //   );
  // }

  if (IsLoggedIn === false && window.location.pathname.search("CustomerPage") === -1) {
    debugger;
    return (
      <ThemeProvider theme={theme}>
        <LoginGlass setIsLoggedIn={setIsLoggedIn} />
      </ThemeProvider>
    );
  }
  else if (IsLoggedIn === false && window.location.pathname.search("CustomerPage") === 1) {
    return (
      <ThemeProvider theme={theme}>
        <CustomerPage />
      </ThemeProvider>
    );
  }
  else {
    return (
      <ThemeProvider theme={theme}>
        <NavBar setIsLoggedIn={setIsLoggedIn} />
      </ThemeProvider>

    );
  }
};

export default App;
